import { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Form, notification } from "antd";
import Secured from "../img/secured_email.png";
import Cross from "../img/close-line.png";
import { API_URL } from "../helpers/constants";
import Loader from "./Loader";
import PhoneInput, { Value } from "react-phone-number-input";
import axios from "axios";

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  initialPhone?: Value;
};

const GetNewPin = (props: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState<Value | undefined>(props.initialPhone);

  const handleSubmit = () => {
    setLoading(true);
    const formattedPhone = phone?.replace(/\s+/g, "");

    axios
      .post(`${API_URL}/v2/auth/get-new-pin`, {
        phone: formattedPhone,
      })
      .then((response) => {
        setLoading(false);
        notification.success({
          message: "PIN request sent",
          description: "You will receive a new PIN shortly",
        });
        close();
      })
      .catch((error) => {
        setLoading(false);
        notification.error({
          message: "Failed to send PIN",
          description:
            error?.response?.data?.message || "Please try again later",
        });
      });
  };

  const close = () => {
    form.resetFields();
    setPhone(props.initialPhone);
    props.handleClose();
  };

  return (
    <Transition.Root show={props.isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={close}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative text-left p-4 sm:p-6 md:p-10 bg-oya-ghana-modal-background border border-oya-ghana-border shadow-form rounded-xl">
                <div className="flex items-start justify-between">
                  <div className="flex items-start">
                    <img src={Secured} alt="Secured phone" />
                    <h3 className="text-oya-ghana-header-h5 pb-5 pl-4">
                      Get New PIN
                    </h3>
                  </div>

                  <div
                    className="border-2 border-oya-ghana-border p-2 rounded-full cursor-pointer ml-4"
                    onClick={close}
                  >
                    <img
                      src={Cross}
                      alt="close button"
                      style={{ width: 20, height: 20 }}
                    />
                  </div>
                </div>

                <Form
                  className="w-full"
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                >
                  <p className="text-sm py-5">
                    Enter your phone number to request a new PIN.
                    <br />
                    You will receive it via SMS.
                  </p>

                  <Form.Item
                    label={
                      <label
                        htmlFor="phone"
                        className="block capitalize text-sm text-gray-601"
                      >
                        Phone Number
                      </label>
                    }
                    name="phone"
                    className="w-full mb-2 pr-3"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                    colon={false}
                    required={true}
                  >
                    <PhoneInput
                      id="phone"
                      name="phone"
                      className="w-full px-4 mt-2 mb-4 border border-gray-200 rounded-md outline-none h-10 focus:border-gray-200 focus:outline-none"
                      defaultCountry="GH"
                      disabled={loading}
                      value={phone}
                      onChange={(e) => {
                        setPhone(e);
                      }}
                    />
                  </Form.Item>

                  <button
                    data-testid="get-new-pin-send-button"
                    type="submit"
                    disabled={loading}
                    className="relative w-full trans flex items-center justify-center my-5 bg-red-101 text-oya-ghana-header-h6 rounded-md py-2 text-white disabled:cursor-not-allowed disabled:bg-gray-400"
                  >
                    {loading ? <Loader /> : "Send PIN"}
                  </button>
                </Form>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default GetNewPin;
